import React, { Fragment, useEffect } from 'react';
import { connect } from '../../redux/store';
import { actions } from '../../redux/modules/service';
import { I18n } from '@kineticdata/react';
import { PageTitle } from '../shared/PageTitle';
import { ContentManager } from '../shared/content_manager/ContentManager';
import { CONTENT_MANAGER_MODE } from '../shared/content_manager/helpers';
import {
  ErrorMessage,
  LoadingMessage,
  C,
  openModalForm,
  selectServicesKappSlug,
} from '@kineticdata/bundle-common';

const ServiceComponent = ({
  portfolioId,
  serviceId,
  loading,
  error,
  service,
  serviceName,
  serviceShortDesc,
  portfolioName,
  fetchService,
  kappSlug,
  appLocation,
  isMobile,
}) => {
  useEffect(
    () => {
      if (serviceId) {
        fetchService(serviceId);
      }
    },
    [fetchService, serviceId],
  );

  const handleFeedback = () =>
    openModalForm({
      formSlug: C.FORM_SLUG_CATALOG_FEEDBACK,
      kappSlug: kappSlug,
      title: `Provide Service Feedback`,
      values: {
        'Catalog Item Id': serviceId,
        'Catalog Item Type': 'Service',
        'Catalog Item Name': serviceName,
        'Catalog Item Form Slug': C.FORM_SLUG_SERVICE,
        'Catalog Submission ID': service.id,
      },
      confirmationMessage: 'Your feedback has been submitted.',
      duration: 5000,
    });

  return (
    <Fragment>
      <div className="page-container">
        <div className="page-panel">
          <PageTitle
            className="page-title-heading--sm"
            parts={[serviceName, portfolioName, 'Service Catalog']}
            suptitle="SERVICE"
            title={serviceName}
            breadcrumbs={[
              {
                label: (
                  <span>
                    <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                    <I18n>Service Catalog</I18n>
                  </span>
                ),
                to: `${appLocation}/servicecatalog`,
              },
              portfolioId &&
                portfolioName && {
                  label: portfolioName,
                  to: '../..',
                },
            ]}
            actions={[
              service && {
                label: 'Provide Feedback',
                onClick: handleFeedback,
                menu: true,
              },
            ]}
          >
            {serviceShortDesc && (
              <div className="page-title__meta">{serviceShortDesc}</div>
            )}
          </PageTitle>

          {error ? (
            <ErrorMessage
              title="The service failed to load."
              message={error.message}
            />
          ) : loading ? (
            <LoadingMessage />
          ) : !!service ? (
            <ContentManager
              submission={service}
              mode={CONTENT_MANAGER_MODE.PUBLIC}
            />
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => {
  // Get the service and portfolio from the list to get the names
  const serviceFromCatalog = state.app.catalog.services.find(
    p => p.values[C.FIELD_SERVICE_ID] === props.serviceId,
  );
  const portfolioFromCatalog = state.app.catalog.portfolios.find(
    p => p.values[C.FIELD_PORTFOLIO_ID] === props.portfolioId,
  );
  return {
    loading: state.service.loading,
    error: state.service.error,
    service: state.service.id === props.serviceId ? state.service.data : null,
    serviceName: serviceFromCatalog ? serviceFromCatalog.values['Name'] : '',
    serviceShortDesc: serviceFromCatalog
      ? serviceFromCatalog.values['Short Description']
      : '',
    portfolioName: portfolioFromCatalog
      ? portfolioFromCatalog.values['Name']
      : '',
    kappSlug: selectServicesKappSlug(state),
    appLocation: state.app.location,
    layoutSize: state.app.layoutSize,
    isMobile: ['small', 'medium'].includes(state.app.layoutSize),
  };
};

const mapDispatchToProps = { fetchService: actions.fetchServiceRequest };

export const Service = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ServiceComponent);
